import React from "react";
import MyDevicesLayer from "../components/devices/MyDevicesLayer";
import MasterLayout from "../masterLayout/MasterLayout";

function MyDevicesPage() {
  return (
    <MasterLayout>
      <MyDevicesLayer />
    </MasterLayout>
  );
}

export default MyDevicesPage;
